import { RYDESEND_WEB_URL } from "../config/url.config"
import { getCookie } from "./cookie";

async function superFetch (endpoint, method, data, token) {

    let customHeader = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + getCookie('RydeSendToken'),
    }

    const response = await fetch(`${RYDESEND_WEB_URL}${endpoint}`, {
        method,
        headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + getCookie('RydeSendToken'),
    },
        body: method === "get" ? undefined : JSON.stringify(data),
    });

    const res = await response.json();

    return res
}

export default superFetch ;